module.exports = __webpack_public_path__ + "static/media/logo.23be0b84.svg";